module.exports = __webpack_public_path__ + "img/12step-02-06-1_ergebnis.92b3f7c6.webp";